export const urlRegex = /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/g;
export const getLinks = (text: string) => {
  const strs = [...text.matchAll(urlRegex)].map(x => x[0]);
  return [...new Set(strs)];
};
